module.exports = __webpack_public_path__ + "img/雷阵雨及伴有冰雹.33d9eade.png";